import { JSX } from "react";
import { useToggleableDialog } from "@shared/common/hooks/useToggleableDialog";
import { PrerequisiteItem } from "@shared/components/SidePanel/PrerequisiteItem";
import { ScenarioBorderSelectionWrapper } from "./ScenarioBorderSelectionWrapper";

export function ScenarioBorderSelectionDialog(): JSX.Element {
  const { dialogRef, isOpen, handleOpenDialog, handleCloseDialog } = useToggleableDialog();

  return (
    <>
      <PrerequisiteItem title="Scenariogrenzen" onClick={handleOpenDialog} />
      <tractie-dialog ref={dialogRef} heading="Scenariogrenzen" size="m">
        {isOpen && <ScenarioBorderSelectionWrapper onClose={handleCloseDialog} />}
      </tractie-dialog>
    </>
  );
}
